// extracted by mini-css-extract-plugin
export default {"root":"EmptyTaskManagement_root__V9Tsg","header":"EmptyTaskManagement_header__+JLQk","button":"EmptyTaskManagement_button__LamED"};